import _ from "@lodash";
import { AppBar, DialogContent, Toolbar, Typography } from "@material-ui/core";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import EmpresaPacienteApp from "app/ERP/EmpresaPaciente/EmpresaPacienteApp";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import MobileDetect from "mobile-detect";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import XAPPButton from "../Button/XAPPButton";
import XAPPDialog from "../Dialog/XAPPDialog";
import * as Actions from "./Store/Actions/MigrarCadastroActions";
import MigrarCadastroReducer from "./Store/Reducers/MigrarCadastroReducer";

const md = new MobileDetect(window.navigator.userAgent);

class MigrarCadastro extends XAPPComponent {

  state = {
    openDialog: false,
    idorigem: null,
    idorigemdescricao: null,
    iddestino: null,
    iddestinodescricao: null,
  };

  componentDidUpdate() {
    if (this.props.Reducer.error) {
      this.props.showMessage({
        message: this.props.Reducer.error,
        variant: "error"
      });
      this.props.Reducer.error = null;
    } if (this.props.Reducer.info) {
      this.props.showMessage({
        message: this.props.Reducer.info,
        variant: "success"
      });
      this.props.Reducer.info = null;
    }
  }

  canBeSubmitted = () => {
    const form = this.state;
    return (!_.isNull(form.idorigem) && !_.isNull(form.iddestino));
  };

  handleChangeCadastro = (_AValue, _AID) => {
    let form = Object.assign({}, this.state);
    if (!_.isNull(_AValue) && _AValue.length > 0) {
      form[_AID] = _AValue[0].idpessoaformulario;
      form[`${_AID}descricao`] = _AValue[0].nome;
    }
    else {
      form[_AID] = null;
      form[`${_AID}descricao`] = null;
    }
    this.setState(_.set({ ...form }));
  };

  render() {
    const { save, xappRouteParams, tipo, className } = this.props;
    const form = this.state;
    return (
      <React.Fragment>
        <XAPPButton
          tooltip={{ "title": "Mesclar cadastros", "placement": "top" }}
          type="Icon"
          className={className}
          onClick={() => this.setState(_.set({ ...form }, "openDialog", true))}
          icon={"merge"}
        />
        <XAPPDialog
          id="MigrarCadastro"
          open={form.openDialog}
          onClose={() => this.setState(_.set({ ...form }, "openDialog", false))}
          fullWidth
          maxWidth={md.mobile() !== null ? "lg" : "sm"}
        >
          <AppBar position="static" elevation={1}>
            <Toolbar className="flex w-full min-h-0">
              <Typography variant="subtitle1 text-white">
                {"Mesclar cadastros"}
              </Typography>
              <div style={{ flex: 1 }} />
              <XAPPButton
                type="Icon"
                className="p-6"
                onClick={() => this.setState(_.set({ ...form }, "openDialog", false))}
                icon={"close"}
              />
            </Toolbar>
          </AppBar>
          <DialogContent classes={{ root: "p-12" }}>
            {tipo === "paciente" &&
              <React.Fragment>
                <EmpresaPacienteApp
                  className="mb-12"
                  xappRouteParams={xappRouteParams}
                  isLookup={true}
                  multiSelect={false}
                  onChange={(ev) => this.handleChangeCadastro(ev, "idorigem")}
                  selected={!_.isNull(form.idorigem) ? [{ id: form.idorigem, idpessoaformulario: form.idorigem, label: form.idorigemdescricao, nome: form.idorigemdescricao }] : []}
                  id="idorigem"
                  label="Origem"
                />
                <EmpresaPacienteApp
                  className="mb-12"
                  xappRouteParams={xappRouteParams}
                  isLookup={true}
                  multiSelect={false}
                  onChange={(ev) => this.handleChangeCadastro(ev, "iddestino")}
                  selected={!_.isNull(form.iddestino) ? [{ id: form.iddestino, idpessoaformulario: form.iddestino, label: form.iddestinodescricao, nome: form.iddestinodescricao }] : []}
                  id="iddestino"
                  label="Destino"
                />
              </React.Fragment>
            }
            <div className="flex mb-12 justify-center items-center">
              <XAPPButton
                type="Button"
                className="bg-green hover:bg-green text-white h-32"
                variant="contained"
                color="primary"
                onClick={() => save(form, xappRouteParams)}
                disabled={!this.canBeSubmitted()}
                iconProps={"mr-8"}
                label={"ok"}
              />
            </div>
          </DialogContent>
        </XAPPDialog>
      </React.Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    save: Actions.save,
    showMessage: AppActions.showMessage
  }, dispatch);
}

function mapStateToProps({ MigrarCadastro }) {
  return {
    Reducer: MigrarCadastro
  };
}

export default withReducer("MigrarCadastro", MigrarCadastroReducer)(withRouter(connect(mapStateToProps, mapDispatchToProps)(MigrarCadastro)));
